import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Pagamento } from "../../../../services/Pagamento";
import { FormaPagamentoEnum } from "../../../../enums/formaPagamento";

export const useGerarFatura = () => {
  return useMutation({
    mutationFn: ({
      uuidAgendamento,
      formaPagamento,
    }: {
      uuidAgendamento: string;
      formaPagamento: FormaPagamentoEnum;
    }) => Pagamento.gerarFatura({ uuidAgendamento, formaPagamento }),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
